<template>
  <div class="fillgrid-full-search">
    <textarea
      class="fillgrid-full-search-input shadow-sm form-control"
      rows="3"
      :id="id"
      :placeholder="placeholder"
      @focusout="focusout"
      @focus="focus"
      @keydown.13="chooseItem"
      @keydown.tab="chooseItem"
      @keydown.40="moveDown"
      @keydown.38="moveUp"
      v-model="inputValue"
      type="text"
    />

    <ul :class="{ 'fillgrid-full-search-list': true, [id + '-list']: true }" v-if="searchMatch.length > 0">
      <li
        :class="{active: selectedIndex === index}"
        v-for="(result, index) in searchMatch"
        :key="index"
        @click="selectItem(index), chooseItem()"
        v-html="highlightWord(result)"
      />
    </ul>
  </div>
</template>

<script>
export default {
  props: ['value', 'items', 'placeholder'],
  data () {
    return {
      id: 'input-' + parseInt(Math.random() * 1000),
      inputValue: '',
      searchMatch: [],
      selectedIndex: 0,
      clickedChooseItem: false,
      wordIndex: 0
    }
  },
  mounted () {
    this.inputValue = this.value
  },
  computed: {
    listToSearch () {
      if (typeof this.items !== 'undefined' && this.items.length > 0) {
        return this.items
      } else {
        return []
      }
    },
    currentWord () {
      return this.inputValue.replace(/(\r\n|\n|\r)/gm, ' ').split(' ')[this.wordIndex]
    },
    inputSplitted () {
      return this.inputValue.replace(/(\r\n|\n|\r)/gm, ' ').split(' ')
    }
  },
  watch: {
    inputValue (val) {
      this.focus()
      this.selectedIndex = 0
      this.wordIndex = this.inputSplitted.length - 1
      this.$emit('input', val)
    },
    value (val) {
      this.inputValue = val || ''
    }
  },
  methods: {
    highlightWord (word) {
      const regex = new RegExp('(' + this.currentWord + ')', 'g')
      return word.replace(regex, '<mark>$1</mark>')
    },
    setWord (word) {
      let currentWords = this.inputValue
        .replace(/(\r\n|\n|\r)/gm, '__br__ ')
        .split(' ')
      currentWords[this.wordIndex] = currentWords[this.wordIndex].replace(
        this.currentWord,
        word + ' '
      )
      this.wordIndex += 1
      this.inputValue = currentWords.join(' ').replace(/__br__\s/g, '\n')
    },
    moveDown () {
      if (this.selectedIndex < this.searchMatch.length - 1) {
        this.selectedIndex++
      }
    },
    moveUp () {
      if (this.selectedIndex !== -1) {
        this.selectedIndex--
      }
    },
    selectItem (index) {
      this.selectedIndex = index
      this.chooseItem()
    },
    chooseItem (e) {
      this.clickedChooseItem = true

      if (this.selectedIndex !== -1 && this.searchMatch.length > 0) {
        if (e) {
          e.preventDefault()
        }
        this.setWord(this.searchMatch[this.selectedIndex])
        this.selectedIndex = -1
      }
    },
    focusout (e) {
      setTimeout(() => {
        if (!this.clickedChooseItem) {
          this.searchMatch = []
          this.selectedIndex = -1
        }
        this.clickedChooseItem = false
      }, 100)
    },
    focus () {
      this.searchMatch = []
      if (this.currentWord && this.currentWord !== '') {
        this.searchMatch = this.currentWord.indexOf('*') === -1 ? this.listToSearch.filter(
          el => el.search(new RegExp('^' + this.currentWord, 'i')) >= 0
        ) : []
      }
      if (
        this.searchMatch.length === 1 &&
        this.currentWord === this.searchMatch[0]
      ) {
        this.searchMatch = []
      }
    }
  }
}
</script>

<style lang="scss">
.fillgrid-full-search {
  position: relative;
  &-input {
    width: 100%;
  }
  &-list {
    position: absolute;
    z-index: 2;

    overflow: auto;

    max-height: 200px;
    margin: 0;
    padding: 0;

    border: 1px solid #eee;

    list-style: none;

    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 -2px 10px #aaaaaa;
    bottom: calc(100% + 5px) !important;
    left: 0 !important;
    right: 0 !important;

    li {
      margin: 0;
      padding: 8px 15px;

      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border-bottom: 0;
      }
      &:hover,
      &.active {
        background-color: #ebebeb;
      }

      mark {
        font-weight: bold;
      }
    }
  }
  mark {
    font-weight: bold !important;
    background-color: #f7d980;
    padding: 0;
  }
}
</style>
